export const brokersConfig = {
    "tableDefinition": {
        "tooltip": "",
        "columns": [
            {
                "name": "brokerNumber",
                "label": "Broker Number",
                "displayField": "akey"
            },
            {
                "name": "status",
                "label": "Status",
                "displayField": "astatus"
            },
            {
                "name": "errorCount",
                "label": "Error Count",
                "displayField": "error_count"
            }
        ]
    }
}